<template>
    <component
        :href="link"
        :class="['z-card', classObject]"
        :style="backgroundImage ? `background-image: url(${backgroundImage}` : ''"
        @click="$emit('click')"
        :is="link ? 'a' : 'div'"
    >
        <div class="z-card__body">
            <header
                class="z-card__header"
                v-if="this.$slots['top']"
            >
                <slot name="top" />
            </header>
            <div class="z-card__main">
                <span
                    class="z-card__title"
                    v-if="this.$slots['title']"
                >
                    <slot name="title" />
                </span>
                <div
                    v-if="this.$slots['content']"
                    class="z-card__content"
                >
                    <slot name="content"></slot>
                </div>
            </div>
            <footer
                class="z-card__footer"
                v-if="this.$slots['bottom']"
            >
                <slot name="bottom" />
            </footer>
        </div>
    </component>
</template>

<script>
export default {
    name: 'z-card',
    props: {
        link: String,
        theme: {
            type: String,
            validator: prop => ['grey'].includes(prop)
        },
        fullHeight: {
            type: Boolean,
            default: false
        },
        minHeight: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: true
        },
        backgroundImage: String
    },
    computed: {
        classObject () {
            return {
                'z-card--link': this.link,
                'z-card--full-height': this.fullHeight,
                'z-card--bordered': this.bordered,
                'z-card--min-height': this.minHeight,
                [`z-card--theme-${this.theme}`]: this.theme
            }
        }
    }
}
</script>

<style lang="scss">
.z-card {
    $parent: &;
    position: relative;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;

    &__body {
        padding: $token-spacers-m;
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
        z-index: 2;

        @include breakpoint (mobile) {
            padding: $token-spacers-2-xs;
        }
    }

    &__main {
        flex-grow: 1;
        flex-shrink: 1;
    }

    &__header {
        @include margin-level(bottom, XS);
        flex-shrink: 0;
        flex-grow: 0;
    }

    &__footer {
        @include padding-level(top, XS);
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        flex-shrink: 0;
        flex-grow: 0;
    }

    &__title {
    }

    &--full-height {
        height: 100%;
    }

    &--min-height {
        min-height: 200px;
    }

    &--bordered {
        border: 1px solid $token-colors-black-15;
    }

    &--theme-grey {
        background: $token-colors-black-5;
    }
}

a.z-card {
    text-decoration: none;
    transition: box-shadow $transition;
    display: block;

    &:hover {
        box-shadow: 0 8px 8px rgba(0, 32, 51, 0.04), 0 12px 28px rgba(0, 32, 51, 0.12);
    }
}
</style>
